import React from "react";

const defaultGrievanceData = [
  "Communities",
  "Investors (other than stakeholders)",
  "Shareholders",
  "Employees & Workers",
  "Customers",
  "Value Chain Partners",
  "Other (please specify)",
].map((source) => ({
  complaintSource: source,
  grievanceInPlace: false,
  grievancePolicyLink: "",
  currentYearComplaints: "",
  currentYearPending: "",
  currentYearRemarks: "",
  previousYearComplaints: "",
  previousYearPending: "",
  previousYearRemarks: "",
}));

const GrievanceMechanismTable = ({ grievanceTable, setGrievanceTable }) => {
  const handleInputChange = (rowIndex, field, value) => {
    const updated = [...grievanceTable];
    updated[rowIndex][field] = value;
    setGrievanceTable(updated);
  };

  const toggleGrievance = (rowIndex) => {
    const updated = [...grievanceTable];
    updated[rowIndex].grievanceInPlace = !updated[rowIndex].grievanceInPlace;
    if (!updated[rowIndex].grievanceInPlace) {
      updated[rowIndex].grievancePolicyLink = "";
    }
    setGrievanceTable(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan={2} style={tableHeaderStyle}>
              Complaint Source
            </th>
            <th style={tableHeaderStyle}>
              Grievance Mechanism in Place? (Yes/No)
              <br />
            </th>
            <th style={tableHeaderStyle} colSpan="3">
              Current Financial Year
            </th>
            <th style={tableHeaderStyle} colSpan="3">
              Previous Financial Year
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}>
              (If Yes, then provide web-link for grievance policy)
            </th>
            <th style={tableHeaderStyle}>
              Number of Complaints Filed in the Year
            </th>
            <th style={tableHeaderStyle}>
              Number of Pending Complaints at Year-End
            </th>
            <th style={tableHeaderStyle}>Remarks</th>
            <th style={tableHeaderStyle}>
              Number of Complaints Filed in the Year
            </th>
            <th style={tableHeaderStyle}>
              Number of Pending Complaints at Year-End
            </th>
            <th style={tableHeaderStyle}>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {grievanceTable.map((row, index) => (
            <tr key={index}>
              <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                {row.complaintSource}
              </td>

              {/* Yes/No Toggle with Label and Web Link under it */}
              <td style={tableCellStyle}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <span style={{ fontSize: 13 }}>No</span>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={row.grievanceInPlace}
                        onChange={() => toggleGrievance(index)}
                      />
                      <span className="slider round"></span>
                    </label>
                    <span style={{ fontSize: 13 }}>Yes</span>
                  </div>
                  {row.grievanceInPlace && (
                    <input
                      type="text"
                      value={row.grievancePolicyLink}
                      placeholder="Enter web link"
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "grievancePolicyLink",
                          e.target.value
                        )
                      }
                      style={{ ...inputFieldStyle, marginTop: 6 }}
                    />
                  )}
                </div>
              </td>

              {/* Current FY */}
              <td style={tableCellStyle}>
                <input
                  type="number"
                  value={row.currentYearComplaints}
                  onChange={(e) =>
                    handleInputChange(
                      index,
                      "currentYearComplaints",
                      e.target.value
                    )
                  }
                  style={inputFieldStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="number"
                  value={row.currentYearPending}
                  onChange={(e) =>
                    handleInputChange(
                      index,
                      "currentYearPending",
                      e.target.value
                    )
                  }
                  style={inputFieldStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  value={row.currentYearRemarks}
                  onChange={(e) =>
                    handleInputChange(
                      index,
                      "currentYearRemarks",
                      e.target.value
                    )
                  }
                  style={{
                    ...inputFieldStyle,
                    minWidth: "140px", // ⬅️ wider
                    height: "60px", // ⬅️ taller
                    fontSize: "15px", // ⬅️ slightly larger text
                    padding: "8px 10px", // ⬅️ more spacing
                  }}
                />
              </td>

              {/* Previous FY */}
              <td style={tableCellStyle}>
                <input
                  type="number"
                  value={row.previousYearComplaints}
                  onChange={(e) =>
                    handleInputChange(
                      index,
                      "previousYearComplaints",
                      e.target.value
                    )
                  }
                  style={inputFieldStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="number"
                  value={row.previousYearPending}
                  onChange={(e) =>
                    handleInputChange(
                      index,
                      "previousYearPending",
                      e.target.value
                    )
                  }
                  style={inputFieldStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  value={row.previousYearRemarks}
                  onChange={(e) =>
                    handleInputChange(
                      index,
                      "previousYearRemarks",
                      e.target.value
                    )
                  }
                  style={{
                    ...inputFieldStyle,
                    minWidth: "140px", // ⬅️ wider
                    height: "60px", // ⬅️ taller
                    fontSize: "15px", // ⬅️ slightly larger text
                    padding: "8px 10px", // ⬅️ more spacing
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* CSS for toggle switch */}
      <style>{`
        .switch {
          position: relative;
          display: inline-block;
          width: 46px;
          height: 22px;
        }
        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }
        .slider {
          position: absolute;
          cursor: pointer;
          top: 0; left: 0; right: 0; bottom: 0;
          background-color: #ccc;
          transition: .4s;
          border-radius: 24px;
        }
        .slider:before {
          position: absolute;
          content: "";
          height: 16px;
          width: 16px;
          left: 3px;
          bottom: 3px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
        }
        input:checked + .slider {
          background-color: #8a4a68;
        }
        input:checked + .slider:before {
          transform: translateX(24px);
        }
      `}</style>
    </div>
  );
};

const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default GrievanceMechanismTable;
export { defaultGrievanceData };
